import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe, TranslocoModule } from '@ngneat/transloco';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms'; 
import { CommonModule } from '@angular/common'; 




export interface ShareLevelDialogData {
  shareLevel: string;
  shareLevelEdit: string;
  folderName: string;
  alreadyExists: boolean;
  keepSettings:boolean;
}

@Component({
  standalone: true,
  selector: 'app-share-level-dialog',
  styleUrls: ['./share-level-dialog.component.scss'],
  templateUrl: './share-level-dialog.component.html',
  providers: [TranslocoPipe],
  imports: [MatDialogModule,FormsModule, CommonModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule, MatButtonModule, TranslocoModule]
})
export class ShareLevelDialogComponent {

  shareLevelOptions = [
    { value: 'PUB', text: 'modal.shareLevel.pub' },
    { value: 'PRV', text: 'modal.shareLevel.prv' },
    { value: 'DOM', text: 'modal.shareLevel.dom' }
  ];

  editOptions = [
    { value: 'PRV', text: 'modal.shareLevel.prv' },
    { value: 'DOM', text: 'modal.shareLevel.dom' },
    { value: 'PUB', text: 'modal.shareLevel.pub' }
  ];
  
  constructor(
    public dialogRef: MatDialogRef<ShareLevelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ShareLevelDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close(null);
  }

  get filteredEditOptions() {
    if (this.data.shareLevel === 'PRV') {
      return this.editOptions.filter(o => o.value === 'PRV');
    } else if (this.data.shareLevel === 'DOM') {
      return this.editOptions.filter(o => o.value !== 'PUB'); 
    } else {
      // PUB => tutte
      return this.editOptions;
    }
  }

  onConfirm(): void {
    this.dialogRef.close({
      shareLevel: this.data.shareLevel,
      shareLevelEdit: this.data.shareLevelEdit,
      keepSettings: this.data.keepSettings
    });  
  }
}

